import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslations } from "use-intl";
import { FilterQuestions } from "$/modules/question/ui/filter-questions";
import { questionnairesQueryOptions } from "$/modules/questionnaire/lib/queries";
import { ConstructionHeader } from "$/modules/shared/ui/construction-header";
import { NoEntriesContainer } from "$/modules/shared/ui/no-entries";
import { SearchInput } from "$/modules/shared/ui/search-input";

export const Route = createFileRoute(
	"/$locale/$userId/projects/$projectId/questions/",
)({
	component: QuestionBankPage,
	loader: async ({ params, context: { queryClient } }) => {
		await queryClient.ensureQueryData({
			...questionnairesQueryOptions(params.userId, params.projectId),
			revalidateIfStale: true,
		});
	},
});

function QuestionBankPage() {
	const queryKey = "q";
	const { userId, projectId } = Route.useParams();
	const { data: questionnaire } = useSuspenseQuery(
		questionnairesQueryOptions(userId, projectId),
	);
	const t = useTranslations("project.question");
	const computedQuestions = questionnaire.rows.flatMap(
		(q) => q.questions || [],
	);

	return (
		<>
			<ConstructionHeader titleKey={"project.sidebar.questionBank"} />

			{computedQuestions.length > 0 ? (
				<div className="space-y-6">
					<SearchInput queryKey={queryKey} />
					<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 xl:grid-cols-3">
						<FilterQuestions
							inputValue={computedQuestions}
							queryKey={queryKey}
						/>
					</div>
				</div>
			) : (
				<NoEntriesContainer icon="clipboard-list" text={t("noQuestions")} />
			)}
		</>
	);
}
